var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGoBack = function SvgIconGoBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#668091",
    d: "m6.586 13.414 4.293 4.293 1.414-1.414L9 13h10v-2H9l3.293-3.293-1.414-1.414-4.293 4.293a2 2 0 0 0 0 2.828"
  })));
};
export { SvgIconGoBack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNTg1NTEgMTMuNDE0TDEwLjg3ODUgMTcuNzA3TDEyLjI5MjUgMTYuMjkzTDguOTk5NTEgMTNMMTguOTk5NSAxM0wxOC45OTk1IDExTDguOTk5NTEgMTFMMTIuMjkyNSA3LjcwNzAzTDEwLjg3ODUgNi4yOTMwM0w2LjU4NTUxIDEwLjU4NkM2LjIxMDU3IDEwLjk2MTEgNS45OTk5NCAxMS40Njk3IDUuOTk5OTQgMTJDNS45OTk5NCAxMi41MzA0IDYuMjEwNTcgMTMuMDM5IDYuNTg1NTEgMTMuNDE0WiIgZmlsbD0iIzY2ODA5MSIvPgo8L3N2Zz4K";